import React, { useState } from "react";
import {
  BsEyeFill,
  BsFillCalendarFill
} from "react-icons/bs";
import {
  Col,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row
} from "reactstrap";
import {
  applyCustomFontStyles,
  isImageUrl,
  renderCommentsCountTextFormat,
  TEMPLATE_TYPE_MAP, trivvyFromCustomTemplates
} from "../data";
import debounce from "lodash.debounce";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { stripHtmlTags } from "../../../utils/constants";
import QuizTextEditor from "../../../components/QuizTextEditor/QuizTextEditor";
import UploadMediaModal from "./UploadMediaModal";
import "../trivia-survey.css";
import ReactPlayer from "react-player";
import WrapLinkedRewards from "./WrapLinkedRewards";
import { isMobile as isMobileDevice } from "../../../utils/deviceInfo";
import moment from "moment";
import { AiFillClockCircle } from "react-icons/ai";
import TriviaCommentsComponent from "./TriviaCommentsComponent";
import {
  LuImage,
  LuLink2,
  LuListChecks,
  LuMessageSquare,
  LuTrash2,
} from "react-icons/lu";
import { EDIT_ADD_MEDIA } from "./editCopy";
import parse from 'html-react-parser'
import ViewSummaryCommon from "../../../components/Trivvy/ViewSummarycomon";
import { ONE_WAY_MESSAGE_TRAILER } from "../../../utils/constants";
import { USER_CONTENT_WARNING_TEXT } from "../../../utils/userContentWarning";

export default function TriviaWelcomeComponent({
  welcomeData,
  editWelcomeData,
  view,
  themeSettings,
  callApiToAutoSave,
  uploadUrl,
  quizName,
  noOfQuestions,
  isEditable,

  totalQuizSeconds,
  noOfMCQs,
  linkedRewards,
  quizEndDate,
  timedQuestionsEnable,
  isBannerOpen,
  setIsBannerOpen,
  uploadText,
  templateType,
  customTemplateData,
  editTrivvyByKey,
  triviaData,
  holidayTemplateName,
  welcomeComments,
  updateTriviaComments,
  isMixedTimedMcqTrivvy,
  userContentWarning,
}) {
  // const [isBannerOpen, setIsBannerOpen] = useState(false);

  // const openBannerModal = () => {
  //   setIsBannerOpen(!isBannerOpen);
  // };
  const [commentsPopoverOpen, setCommentsPopoverOpen] = useState(false);

  const [customDataModal, setCustomDataModal] = useState(null);

  const [textareaHeight, setTextareaHeight] = useState(
    triviaData && triviaData.name.length > 20
      ? `${Math.ceil(triviaData.name.length / 30) * 70}px`
      : "70px"
  );

  const setBannerImg = (image) => {
    const doc = {
      ...welcomeData,
    };

    if (image.file) {
      doc["media_url"] = image.url;

      editWelcomeData(doc);
      const formData = new FormData();

      formData.append("image", image.file);

      axios
        .post(url.uploadTriviaImages, formData)
        .then(({ data }) => {
          console.log('121 data --- ', data)
          doc["media_url"] = data.data.url;
          doc["media_type"] = image.file.type;
          doc['s3Key'] = data.data.s3Key
          editWelcomeData(doc);
          callApiToAutoSave("welcomePage", doc);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      doc["media_url"] = image.url;
      doc["media_type"] = image.type;
      callApiToAutoSave("welcomePage", doc);
      editWelcomeData(doc);
    }
  };

  const removeBannerImg = () => {
    const data = {
      ...welcomeData,
      media_url: "",
    };

    editWelcomeData(data);
    callApiToAutoSave("welcomePage", data);
  };

  const isMobile = view === "MOBILE" || isMobileDevice;

  const isMessaging = triviaData && triviaData.isMessaging
  const isOneWay = triviaData && triviaData.isOneWay === true

  const isSurvey = triviaData && triviaData.triviaCategoryType === "SURVEY" && !triviaData.isMessaging

  // Every row in the details panel is conditional. On a Message they can all be
  // off, and the restyled panel would then render as an empty card.
  const hasWelcomeDetails =
    (linkedRewards && linkedRewards.length) ||
    (triviaData && triviaData.triviaType !== 2) ||
    !isMessaging;

  const lastFieldValuesRef = React.useRef({});


  console.log({ isMobile });
  const saveRef = React.useRef(callApiToAutoSave);
  React.useEffect(() => {
    saveRef.current = callApiToAutoSave;
  }, [callApiToAutoSave]);

  const debounceAutoSave = React.useMemo(
    () =>
      debounce((...args) => {
        console.log("🔁 debounced save fired with args:", args);
        if (typeof saveRef.current === "function") {
          return saveRef.current.apply(null, args);
        }
        return undefined;
      }, 1000),
    []
  );

  React.useEffect(() => {
    return () => {
      debounceAutoSave.cancel();
    };
  }, [debounceAutoSave]);

  const flushAutoSave = React.useCallback(() => {
    debounceAutoSave.flush();
  }, [debounceAutoSave]);


  // const editQuestionText = (key, value) => {
  //   const data = {
  //     ...welcomeData,
  //   };
  //   if(key == "heading"){
  //     data['description'] = value
  //   }

  //   data[key] = value;

  //   editWelcomeData(data);
  //   debounceAutoSave("welcomePage", data);
  // };

  // const editQuestionText = React.useCallback(
  //   (key, value) => {
  //     const prev = welcomeData;
  //     const next = { ...prev };
  //     console.log('179 ---- ')
  //     if (key === "heading") {
  //       const noHeadingChange = prev.heading === value;
  //       const noDescriptionChange = prev.description === value;
  
  //       // 🔒 nothing changed, bail out — no state update, no autosave
  //       if (noHeadingChange && noDescriptionChange) {
  //         return;
  //       }
  
  //       next.heading = value;
  //       next.description = value;
  //     } else {
  //       // For any other key, also guard against no-op updates
  //       if (prev[key] === value) {
  //         return;
  //       }
  //       next[key] = value;
  //     }
  
  //     // ✅ only runs when there's a real change
  //     editWelcomeData(next);
  //     debounceAutoSave("welcomePage", next);
  //   },
  //   [welcomeData, editWelcomeData, debounceAutoSave]
  // );

  // const editQuestionText = (key, value) => {
  //   const data = {
  //     ...welcomeData,
  //   };

  //   console.log(key,'--- value 215---', value)
  
  //   if (key === "heading") {
  //     data["description"] = value;
  //   }
  
  //   data[key] = value;
  
  //   // 🔒 If value for this key hasn't changed since last time, don't autosave again
  //   console.log('224 -- ', lastFieldValuesRef)
  //   const lastVal = lastFieldValuesRef.current[key];
  //   console.log('lastVal 226 --- ', lastVal)
  //   if (lastVal === value) {
  //     console.log('228-----')
  //     // optional: if you *really* don't want even a state update, you can early return
  //     // return;
  
  //     // keep state in sync, but do NOT call debounceAutoSave again
  //     editWelcomeData(data);
  //     return;
  //   }
  
  //   // ✅ Record new value and trigger debounced autosave
  //   lastFieldValuesRef.current[key] = value;
  
  //   editWelcomeData(data);
  //   debounceAutoSave("welcomePage", data);
  // };
  
  const editQuestionText = (key, value) => {
    // clone current welcomeData
    var data = {
      ...welcomeData,
    };
  
    // for heading, also mirror into description
    if (key === "heading") {
      data.description = value;
    }
  
    data[key] = value;
  
    // Get last value we saw for this key
    var lastVal = lastFieldValuesRef.current[key];
  
    // If same as before, don't autosave again
    if (lastVal === value) {
      // still keep local state in sync
      editWelcomeData(data);
      return;
    }
  
    // Record new value for this key
    lastFieldValuesRef.current[key] = value;
  
    // Update local state
    editWelcomeData(data);
  
    // Debounced autosave
    debounceAutoSave("welcomePage", data);
  };
  



  const setComments = (newComments) => {
    const data = {
      ...welcomeData,
      commentsCount: newComments.length,
    };
    updateTriviaComments("WELCOME", newComments);
    editWelcomeData(data);
    callApiToAutoSave("welcomePage", data);
  };

  // const editTrivvyTitle = (e) => {
  //   let val = e.target.value;
  //   setTextareaHeight(`${e.target.scrollHeight}px`);
  //   if (val && val.length > 100) val = val.slice(0, 100);
  //   editTrivvyByKey("name", val);
  //   debounceAutoSave("name", val);
  // };

  // const editTrivvyTitle = React.useCallback(
  //   (e) => {
  //     let val = e.target.value;
  //     setTextareaHeight(`${e.target.scrollHeight}px`);
  //     if (val && val.length > 100) val = val.slice(0, 100);
  
  //     if (val === quizName) {
  //       return; // no actual change, don't autosave
  //     }
  
  //     editTrivvyByKey("name", val);
  //     debounceAutoSave("name", val);
  //   },
  //   [quizName, editTrivvyByKey, debounceAutoSave]
  // );

  const editTrivvyTitle = (e) => {
    let val = e.target.value;
    setTextareaHeight(`${e.target.scrollHeight}px`);
    if (val && val.length > 100) val = val.slice(0, 100);
  
    // If same as before, don't autosave again
    if (lastFieldValuesRef.current["name"] === val) {
      editTrivvyByKey("name", val);
      return;
    }
  
    lastFieldValuesRef.current["name"] = val;
  
    editTrivvyByKey("name", val);
    debounceAutoSave("name", val);
  };
  

  // QuizTextEditor hands back a value, not an event, and the 100 limit counts
  // visible characters so markup never eats the user's budget.
  const editTrivvyTitleRich = (value) => {
    let val = value || "";
    if (stripHtmlTags(val).length > 100) {
      return;
    }
    if (lastFieldValuesRef.current["name"] === val) {
      editTrivvyByKey("name", val);
      return;
    }
    lastFieldValuesRef.current["name"] = val;
    editTrivvyByKey("name", val);
    debounceAutoSave("name", val);
  };

  const headingValue =
    welcomeData && welcomeData.heading
      ? welcomeData.heading.indexOf("One thing before you go") > -1
        ? ""
        : welcomeData.heading
      : "";

  console.log({ totalQuizSeconds });


  const isMediaType = (data, type) =>{
    return (
      data &&
      typeof data.media_type === "string" &&
      data.media_type.toLowerCase().indexOf(type.toLowerCase()) > -1
    );
  }

  if (totalQuizSeconds == 0) {
    totalQuizSeconds = "Not timed";
  }
  // else if (totalQuizSeconds == "MCQ_MIXED") {
  //   totalQuizSeconds = "Multiple Choice Questions are timed";
  // }
  else {
    if (isMixedTimedMcqTrivvy) {
      totalQuizSeconds = "Multiple Choice Questions are timed";
    } else {
      totalQuizSeconds = `Takes ${totalQuizSeconds} seconds`;
    }
  }

  console.log('is Editable 222 -- ', isEditable)

  return (
    <div
      className={`${isEditable ? "" : "trivia-edit-disabled-add-opacity"} ${
        isMobile
          ? "trivia-survey-edit-questions-ui-mobile py-3 mt-0"
          : "trivia-survey-edit-questions-ui py-0"
      }`}
      style={{
        ...(!isMobile && { padding: "0px" }),
        backgroundColor: themeSettings.quizBackgroundColor,
        color: themeSettings.quizTextColor,
      }}
    >
      {isMobile && !isMessaging ? (
        welcomeData.media_url ? (
          <div className="trivia-assets">
            {isMediaType(welcomeData, 'video')  ? (
              <ReactPlayer
                maxHeight="250px"
                width="100%"
                playing={true}
                controls={true}
                loop={true}
                playsinline
                url={welcomeData.media_url}
                style={{ backgroundColor: "black" }}
              />
            ) : (
              <img
              className="trivvy-image-fit"
                src={welcomeData.media_url}
                style={{
                  maxHeight: "250px",
                  maxWidth: "100%",
                }}
              />
            )}
          </div>
        ) : (
          ""
        )
      ) : (
        ""
      )}

      {isBannerOpen && (
        <UploadMediaModal
          open={isBannerOpen}
          onClose={() => setIsBannerOpen(false)}
          setBannerImg={setBannerImg}
          selectedMedia={
            welcomeData && welcomeData.media_url
              ? [{ url: welcomeData.media_url, type: welcomeData.media_type }]
              : []
          }
          removeBannerImg={removeBannerImg}
        />
      )}

      <Row className="px-3">
        <Col
          sm={isMobile || isMessaging? 12 : 6}
          style={{
            position: "relative",
            ...(!isMobile && {
              // maxHeight: "500px",
              overflowY: "auto",
              overflowX: "hidden",
            }),
          }}
          className="hide-scroll px-0"
        >
          {" "}
          <div
            style={applyCustomFontStyles(themeSettings)}
          >
            <div
              className={!isMobile ? "mt-0 pl-4" : "mt-0 limit-height-400"}
              style={{
                ...(isMobile && {
                  paddingInline: "40px",
                }),
              }}
            >
              <div
                style={{
                  width: "100%",
                  // fontSize: isMobile ? "30px" : "46px",
                }}
                className="trivia-survey-edit-questions-ui_trivvy_title d-block mt-0"
              >
                <span className="font-11px">
                  {stripHtmlTags(quizName || '').length}/100 {isMessaging?'(Message title)':''}
                </span>
                {isEditable?
                 <QuizTextEditor
                   value={quizName}
                   onChange={editTrivvyTitleRich}
                   onBlur={flushAutoSave}
                   placeholder="Edit Trivvy title here..."
                   styles={{ width: "100%" }}
                   blockId={9}
                   titleToolbar
                   disabled={!isEditable}
                   questionThemeSettings={themeSettings}
                 />:
               <span
                style={{
                  width: "100%",
                  display:'block',
                  lineHeight:'2.5em',
                  opacity: "0.8",
                  fontSize: "22px",
                  fontStyle:"inherit",
                  ...(!isMobile && {
                    // height: textareaHeight,
                    height: 'auto',
                  }),
                }}
               >
                {parse(quizName || "")}
               </span>
                
              }
               
              </div>

              <div style={{ flex: 1, marginTop: "0%" }}>
                <div className={`trivia-survey-edit-questions-ui_question_title ${isMessaging?'isMessaging':''}`}>
                  <QuizTextEditor
                    value={headingValue}
                    onChange={(value) => editQuestionText("heading", value)}
                    onBlur={flushAutoSave}
                    placeholder="Add your subtitle here..."
                    styles={{
                      width: "100%",
                      // fontSize: isMobile ? "24px" : "32px",
                    }}
                    blockId={1}
                    isMessaging = {isMessaging}
                    disabled={!isEditable}
                    maxLimit={1500}
                    questionThemeSettings={themeSettings}
                  />
                </div>
                {/* Warning sits BELOW the message content. Kept outside the
                    .trivia-survey-edit-questions-ui_question_title wrapper
                    because that wrapper is `display: flex` — placing the <p>
                    inside it would lay the warning out as a flex *row* item
                    beside the editor instead of stacking below it.
                    paddingLeft 15px matches the .ql-editor's internal left
                    padding so the warning lines up with the message content
                    text rather than the "(Message content)" label above it. */}
                {/* 6.a: also hide the content warning on the Edit screen for 1-way
                    messages (a 1-way message expects no reply), matching the
                    take-screen suppression in MessaginSurvey / TriviaQuestionBlock. */}
                {isMessaging && userContentWarning && !(triviaData && triviaData.isOneWay === true) && (
                  <p
                    className="text-muted mt-2 mb-3"
                    style={{ paddingLeft: "16px" }}
                  >
                    <small>{USER_CONTENT_WARNING_TEXT}</small>
                  </p>
                )}

                {/* 3.a.i: show the 1-way trailer on the Edit-screen preview so the
                    Admin sees the line appended to the sent message. Kept OUTSIDE the
                    .trivia-survey-edit-questions-ui_question_title flex wrapper above so
                    it stacks below the editor; pl-3 (16px) lines it up with the message
                    content text, mt-3 is the blank line before it. */}
                {isMessaging && isOneWay && (
                  <p className="pl-3 mt-3 mb-2">{ONE_WAY_MESSAGE_TRAILER}</p>
                )}

                {quizEndDate ? (
                  <div className="mt-4 pl-2">
                    <BsFillCalendarFill /> End Date -{" "}
                    {moment(quizEndDate).format("MM/DD/YYYY")}
                  </div>
                ) : (
                  ""
                )}

                {hasWelcomeDetails ? (
                <div
                  className={`${
                    quizEndDate ? "mt-3" : "mt-4"
                  } pl-2 trivvy-welcome-edit-details-txt`}
                >
                  {linkedRewards && linkedRewards.length ? (
                    <div
                      style={{
                        wordBreak: "break-all",
                      }}
                    >
                      Take this Trivvy to win exciting rewards:
                      <WrapLinkedRewards rewards={linkedRewards} />
                    </div>
                  ) : (
                    ""
                  )}

                  {triviaData && triviaData.triviaType !== 2 ? (
                    <div
                      style={{
                        wordBreak: "break-all",
                      }}
                    >
                      {" "}
                      <LuLink2 /> <span>Generated on  </span> 
                      {holidayTemplateName ? (
                        <b>{holidayTemplateName}</b>
                      ) : uploadUrl ? (
                        <a
                          href="#"
                          onClick={function(e) {
                            e.preventDefault();
                            var triviaId = triviaData && triviaData._id;
                            if (triviaId) {
                              axios.get(url.getSignedUrl, {
                                params: { id: triviaId, model: 'TriviaTemplate', inline: 1 }
                              }).then(function(res) {
                                var signedUrl = res.data && res.data.url;
                                if (signedUrl) {
                                  window.open(signedUrl, '_blank');
                                } else {
                                  window.open(uploadUrl, '_blank');
                                }
                              }).catch(function() {
                                window.open(uploadUrl, '_blank');
                              });
                            } else {
                              window.open(uploadUrl, '_blank');
                            }
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          link
                        </a>
                      ) : uploadText && uploadText.length ? (
                        <span
                          className="cursor-pointer"
                          onClick={() => setCustomDataModal(uploadText)}
                        >
                          <b className="bwai-edit-panel-value">Custom Text</b>
                          <small> (Click to see text)</small>
                        </span>
                      ) : templateType &&
                        trivvyFromCustomTemplates({ templateType }) &&
                        customTemplateData ? (
                        <span className="cursor-pointer">
                          <b
                            className="text-info"
                            onClick={() => {
                              const html = (
                                <ul>
                                  {customTemplateData.industry ? (
                                    <li>
                                      {" "}
                                      <b> Industry: </b>
                                      {customTemplateData.industry}
                                    </li>
                                  ) : (
                                    ""
                                  )}
                                  {customTemplateData.jobCategory ? (
                                    <li>
                                      <b>Job category: </b>{" "}
                                      {customTemplateData.jobCategory}
                                    </li>
                                  ) : (
                                    ""
                                  )}
                                  {customTemplateData.occupation ? (
                                    <li>
                                      {" "}
                                      <b>Occupation: </b>{" "}
                                      {customTemplateData.occupation}
                                    </li>
                                  ) : (
                                    ""
                                  )}
                                  {customTemplateData.workFlexibility ? (
                                    <li>
                                      <b>Work flexibility: </b>
                                      {customTemplateData.workFlexibility}
                                    </li>
                                  ) : (
                                    ""
                                  )}
                                </ul>
                              );
                              setCustomDataModal(html);
                            }}
                          >
                            {TEMPLATE_TYPE_MAP[templateType]}
                            <small> (view)</small>
                          </b>
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}

                  {customDataModal && (
                    <Modal isOpen={true} className="bwai-edit-modal">
                      <ModalHeader
                        className="trivia_modal_header_bg"
                        toggle={() => setCustomDataModal(null)}
                      >
                        Custom Data
                      </ModalHeader>
                      <ModalBody className="p-3">{customDataModal}</ModalBody>
                    </Modal>
                  )}

                  {!isMessaging?
                  <div>
                    {" "}
                    <LuListChecks /> Questions:{" "}
                    <span className="bwai-edit-panel-value">
                      {noOfQuestions}
                    </span>
                  </div>
                   :null}
                </div>
                ) : null}

                {!isMobile && !isMessaging && (
                  <div
                  className="trivvy-edit-lf-btn-container"
                    // className="mt-4 pt-5 pl-2"
                    style={{
                      // textAlign: "center",
                      // fontSize:'0.94em',
                      // width: "80%",
                      padding: isMobile ? "0px 4%" : "",
                    }}
                  >
                    {timedQuestionsEnable && !isSurvey ? (
                      <div className="mb-3 align-items-center flex">
                        <AiFillClockCircle className="mr-1" />
                        {totalQuizSeconds}
                      </div>
                    ) : (
                      <></>
                      // <div className="mb-3 align-items-center flex">
                      //   <AiFillClockCircle className="mr-1"/>
                      //   Not timed
                      // </div>
                    )}

                   {
                    triviaData && triviaData.librarySummaryText ?      <div className="my-3"> <ViewSummaryCommon summaryText={triviaData.librarySummaryText} btnUi={
                      <span className="view-summary-styles">  <BsEyeFill className="mr-1" />  View summary</span>
                    } /> </div> :""
                   }

                  {triviaData && triviaData.allowAnonymousResponses?
                    <div className="mb-3">
                       <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="mr-1" viewBox="0 0 16 16" className="anonymousIcon">
                        <path fill-rule="evenodd" d="m4.736 1.968-.892 3.269-.014.058C2.113 5.568 1 6.006 1 6.5 1 7.328 4.134 8 8 8s7-.672 7-1.5c0-.494-1.113-.932-2.83-1.205l-.014-.058-.892-3.27c-.146-.533-.698-.849-1.239-.734C9.411 1.363 8.62 1.5 8 1.5s-1.411-.136-2.025-.267c-.541-.115-1.093.2-1.239.735m.015 3.867a.25.25 0 0 1 .274-.224c.9.092 1.91.143 2.975.143a30 30 0 0 0 2.975-.143.25.25 0 0 1 .05.498c-.918.093-1.944.145-3.025.145s-2.107-.052-3.025-.145a.25.25 0 0 1-.224-.274M3.5 10h2a.5.5 0 0 1 .5.5v1a1.5 1.5 0 0 1-3 0v-1a.5.5 0 0 1 .5-.5m-1.5.5q.001-.264.085-.5H2a.5.5 0 0 1 0-1h3.5a1.5 1.5 0 0 1 1.488 1.312 3.5 3.5 0 0 1 2.024 0A1.5 1.5 0 0 1 10.5 9H14a.5.5 0 0 1 0 1h-.085q.084.236.085.5v1a2.5 2.5 0 0 1-5 0v-.14l-.21-.07a2.5 2.5 0 0 0-1.58 0l-.21.07v.14a2.5 2.5 0 0 1-5 0zm8.5-.5h2a.5.5 0 0 1 .5.5v1a1.5 1.5 0 0 1-3 0v-1a.5.5 0 0 1 .5-.5"/>
                      </svg>
                    This Trivvy allows anonymous submissions
                    </div>
                  :
                    null
                  }
                    <input
                      className={
                        isMobile
                          ? " trivia_ip_btn "
                          : "edit_survey_question_wrapper_noborder trivia_ip_btn trivvy-start-btn-styles"
                      }
                      value={welcomeData.buttonText}
                      onChange={(e) => {
                        editQuestionText("buttonText", e.target.value);
                      }}
                      style={{
                        color: welcomeData.startButtonSettings
                          ? welcomeData.startButtonSettings.color
                          : "rgb(255, 69, 0)",
                        backgroundColor: welcomeData.startButtonSettings
                          ? welcomeData.startButtonSettings.backgroundColor
                          : "rgb(0, 0, 255)",

                        border: `1px solid ${
                          welcomeData.startButtonSettings
                            ? welcomeData.startButtonSettings.color
                            : "rgb(253, 236, 232)"
                        }`,
                        width: "100%",
                        fontSize: "16px",
                        fontWeight: 600,
                        minHeight: "46px",
                        borderRadius: "8px",
                        textAlign: "center",
                        fontStyle:"inherit",
                      }}
                      disabled={!isEditable}
                    />
                    {/* </button> */}
                  </div>
                )}
              </div>
            </div>
            {isMobile && !isMessaging && (
              <div
                className="text-center mt-5"
                style={{
                  position: "relative",
                  bottom: 0,
                  backgroundColor: themeSettings.quizBackgroundColor,
                  width: "100%",
                  // zIndex: 9999999,
                }}
              >
                <div
                  style={{
                    paddingBottom: "10px",
                    paddingTop: "10px",
                    width: "100%",
                    fontSize:'0.94em',
                    backgroundColor: "rgba(0, 0, 0, 0.07)",
                  }}
                >
                  {!isSurvey && (
                    timedQuestionsEnable ? (
                      <div className="mb-2">
                        <AiFillClockCircle className="mr-1" />
                        {totalQuizSeconds}
                      </div>
                    ) : (
                      <div className="mb-2">
                        <AiFillClockCircle className="mr-1" />
                        Not timed
                      </div>
                    )
                  )}


                  {triviaData && triviaData.allowAnonymousResponses?
                    <div className="mb-3">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="mr-1" viewBox="0 0 16 16" className="anonymousIcon">
                        <path fill-rule="evenodd" d="m4.736 1.968-.892 3.269-.014.058C2.113 5.568 1 6.006 1 6.5 1 7.328 4.134 8 8 8s7-.672 7-1.5c0-.494-1.113-.932-2.83-1.205l-.014-.058-.892-3.27c-.146-.533-.698-.849-1.239-.734C9.411 1.363 8.62 1.5 8 1.5s-1.411-.136-2.025-.267c-.541-.115-1.093.2-1.239.735m.015 3.867a.25.25 0 0 1 .274-.224c.9.092 1.91.143 2.975.143a30 30 0 0 0 2.975-.143.25.25 0 0 1 .05.498c-.918.093-1.944.145-3.025.145s-2.107-.052-3.025-.145a.25.25 0 0 1-.224-.274M3.5 10h2a.5.5 0 0 1 .5.5v1a1.5 1.5 0 0 1-3 0v-1a.5.5 0 0 1 .5-.5m-1.5.5q.001-.264.085-.5H2a.5.5 0 0 1 0-1h3.5a1.5 1.5 0 0 1 1.488 1.312 3.5 3.5 0 0 1 2.024 0A1.5 1.5 0 0 1 10.5 9H14a.5.5 0 0 1 0 1h-.085q.084.236.085.5v1a2.5 2.5 0 0 1-5 0v-.14l-.21-.07a2.5 2.5 0 0 0-1.58 0l-.21.07v.14a2.5 2.5 0 0 1-5 0zm8.5-.5h2a.5.5 0 0 1 .5.5v1a1.5 1.5 0 0 1-3 0v-1a.5.5 0 0 1 .5-.5"/>
                      </svg>
                    This Trivvy allows anonymous submissions
                    </div>
                  :
                    null
                  }
                 


                  <input
                    className={
                      isMobile
                        ? " trivia_ip_btn "
                        : "edit_survey_question_wrapper_noborder trivia_ip_btn trivvy-start-btn-styles"
                    }
                    value={welcomeData.buttonText}
                    onChange={(e) => {
                      editQuestionText("buttonText", e.target.value);
                    }}
                    style={{
                      color: welcomeData.startButtonSettings
                        ? welcomeData.startButtonSettings.color
                        : "rgb(255, 69, 0)",
                      backgroundColor: welcomeData.startButtonSettings
                        ? welcomeData.startButtonSettings.backgroundColor
                        : "rgb(0, 0, 255)",
                      fontSize: "25px",

                      minHeight: "32px",
                      border: `1px solid ${
                        welcomeData.startButtonSettings
                          ? welcomeData.startButtonSettings.color
                          : "rgb(253, 236, 232)"
                      }`,
                      borderRadius: "8px",
                      textAlign: "center",
                      minWidth: "150px",
                      maxWidth: "90%%",
                      height: "50px",
                    }}
                    disabled={!isEditable}
                  />
                </div>
              </div>
            )}
          </div>
        </Col>

        {!isMobile && !isMessaging ? (
          <Col
            sm={6}
            className="px-0 trivvy-welcome-component-image50"
            onClick={isEditable ? () => setIsBannerOpen(true) : null}
            style={{overflow:'hidden'}}
          >
            {isImageUrl(welcomeData) ? (
              <div
                className="trivvy_wc__bg_image_blur"
                style={{
                  // height: "500px",
                  backgroundImage: `url(${welcomeData.media_url})`,
                }}
              ></div>
            ) : (
              ""
            )}

            <div
              className="trivia_question_image_upload"
              style={{
                ...(!isMobile && {
                  minHeight: "420px",
                  maxHeight: "420px",
                  height: "60px",
                }),
              }}
            >
              {welcomeData.media_url ? (
                <div className="trivia-assets"
                style={{
                  height: isMediaType(welcomeData, 'video') ?'100%':'auto'
                }}
                >
                  {isMediaType(welcomeData, 'video')  ? (
                    <ReactPlayer
                      className=""
                      height="100%"
                      width="100%"
                      playing={true}
                      playsinline
                      controls={true}
                      loop={true}
                      url={welcomeData.media_url}
                      style={{
                        backgroundColor: "black",
                        //marginTop: "60px",
                        //marginLeft: "7%",
                        //marginRight: "7%",
                        //marginTop: "100px",
                        //marginBottom: "100px",
                        //position: "absolute",
                      }}
                    />
                  ) : (
                    <img
                      src={welcomeData.media_url}
                      className="trivvy-image-fit"
                      style={{
                        maxWidth: "100%",
                        // padding: "25% 0",
                      }}
                    />
                  )}
                </div>
              ) : (
                ""
              )}

              {isEditable ? (
                <button
                  type="button"
                  className="bwai-edit-media-pill"
                  onClick={() => setIsBannerOpen(true)}
                >
                  <LuImage size={16} />
                  {EDIT_ADD_MEDIA}
                </button>
              ) : (
                ""
              )}

              {isEditable ? (
                <div
                  className="uploadTriviaImageText"
                  // data-tip="Change / Upload image"
                >
                  {" "}
                  <span
                    className="trivia_survey_share_buttons_left_smallWrapper_dark"
                    onClick={() => setIsBannerOpen(true)}
                  >
                    <LuImage size={18} />
                  </span>{" "}
                  {welcomeData.media_url &&
                    welcomeData.media_url.length > 0 && (
                      <span
                        className="trivia_survey_share_buttons_left_smallWrapper_dark bwai-edit-media-delete"
                        onClick={() => removeBannerImg()}
                        data-tip="Delete image"
                      >
                        <LuTrash2 size={18} />
                      </span>
                    )}{" "}
                </div>
              ) : (
                ""
              )}
            </div>
          </Col>
        ) : (
          ""
        )}
      </Row>

      <div className="d-block trivvy-comments-w-container">
        <div
          className="cursor-pointer d-flex align-items-center"
          style={{
            float: "right",
          }}
          onClick={() => setCommentsPopoverOpen(!commentsPopoverOpen)}
        >
          <span
            className="font-styling-right-sidebar-items mr-2"
            id={`comments-popover-x`}
          >
            {" "}
            Comments (
            {renderCommentsCountTextFormat(welcomeData.commentsCount) || 0})
          </span>
          <LuMessageSquare size={16} />
        </div>

        {commentsPopoverOpen && (
          <TriviaCommentsComponent
            commentsPopoverOpen={commentsPopoverOpen}
            setCommentsPopoverOpen={setCommentsPopoverOpen}
            target={`comments-popover-x`}
            comments={welcomeComments}
            setComments={setComments}
            questionId={"WELCOME"}
            triviaId={triviaData._id}
          />
        )}
      </div>
    </div>
  );
}
